import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { updateOrder } from '../orders'

export default function useOrderUpdate() {
  const queryClient = useQueryClient()

  const { mutateAsync, data, reset, isLoading } = useMutation(updateOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('opportunities')
      notification.success({
        message: 'Sucesso!',
        description: 'Atualização realizada com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível atualizar!'
      })
    }
  })

  return { mutateAsync, data, reset, isLoading }
}
